<template>
  <div
    class="header-school"
    :class="headerStyle"
    v-if="$store.getters.schoolCount > 1"
  >
    <div
      class="header-title-wrap"
      @mouseenter="debounceSetShow(true)"
      @mouseleave="debounceSetShow(false)"
    >
      <span class="header-title" :title="schoolInfo.cur_school_name">
        {{ schoolInfo.cur_school_name }}
      </span>
      <i v-if="showSchoolPanel" class="icon-title el-icon-arrow-down"></i>
    </div>
    <transition name="fade">
      <div
        class="school-board"
        v-show="showSchoolPanel && show"
        @mouseenter="debounceSetShow(true)"
        @mouseleave="debounceSetShow(false)"
      >
        <div class="cur-school-wrap">
          <p class="board-title">当前校区</p>
          <span class="cur-school-title">
            <span style="margin-right: 5px">
              [{{ schoolInfo.cur_district_name }}]
            </span>
            <span>{{ schoolInfo.cur_school_name }}</span>
          </span>
        </div>
        <ul class="school-list">
          <p class="board-title">请选择您要访问的校区</p>
          <li
            class="province-wrap"
            v-for="(province, index) in schoolInfo.list"
            :key="index"
          >
            <p class="province-name">{{ province.province_name }}</p>
            <ul
              class="city-wrap"
              v-for="(city, index) in province.city"
              :key="index"
            >
              <p class="city-name">{{ city.city_name }}</p>
              <li class="school-wrap">
                <a
                  class="school-name"
                  v-for="(school, index) in city.schools"
                  :key="index"
                  @click="onSchool(school.school_id)"
                  :title="`[${school.district_name}] ${school.school_name}`"
                >
                  <span class="district">[{{ school.district_name }}]</span>
                  <span class="school">{{ school.school_name }}</span>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "HeaderShool",
  props: {
    headerStyle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      show: false,
      debounceSetShow: this.$pub.debounce(this.setShow, 100),
    };
  },
  computed: {
    schoolInfo() {
      return this.$store.state.school_info;
    },
    showSchoolPanel() {
      return (
        this.$store.state.commonSetting.is_cross_school_buy == 1 ||
        !this.$store.state.token
      );
    },
  },
  created() {},
  methods: {
    setShow(val) {
      this.show = val;
    },
    // on event
    async onSchool(school_id) {
      this.show = false;
      this.$store.commit("setSchoolID", school_id);
      window.location.href = "/";
    },
  },
};
</script>

<style lang="scss" scoped>
/*控制整个滚动条*/
::-webkit-scrollbar {
  width: 20px;
  height: 8px;
}

/*滚动条中间滑动部分*/
::-webkit-scrollbar-thumb {
  border-radius: 12px;
  border: 6px solid transparent;
  box-shadow: 8px 0 0 #666 inset;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.header-school {
  position: relative;
  text-align: left;
  .header-title-wrap {
    display: flex;
    align-items: center;
    height: 100%;
    .header-title {
      display: inline-block;
      font-size: 16px;
      color: #666;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 130px;
    }
    .icon-title {
      color: #8e8e8e;
      font-size: 16px;
      font-weight: bolder;
      margin-left: 4px;
    }
  }
  .school-board {
    background-color: rgba(255, 255, 255, 0.9);
    width: 456px;
    max-height: 560px;
    overflow-y: auto;
    position: absolute;
    right: 0;
    box-shadow: 0px 6px 60px rgba(0, 0, 0, 0.08);
    line-height: 1;
    font-size: 14px;
    .board-title {
      color: #999;
      margin-bottom: 12px;
    }
    .cur-school-wrap {
      padding: 16px 20px;
      border-bottom: 1px solid #e6e6e6;
      .cur-school-title {
        display: inline-block;
        color: $primary-color;
        border: 1px solid $primary-color;
        border-radius: 4px;
        padding: 8px;
      }
    }
    .school-list {
      padding: 16px 20px;
      .board-title {
        margin-bottom: 16px;
      }
      .province-wrap {
        margin-bottom: 20px;
        &:last-of-type {
          margin-bottom: 0;
        }
        .province-name {
          font-size: 16px;
          color: #333;
          font-weight: bold;
          position: relative;
          margin-bottom: 20px;
          &::before {
            content: "";
            display: block;
            position: absolute;
            width: 3px;
            height: 16px;
            background-color: $primary-color;
            left: -10px;
          }
        }
        .city-wrap {
          margin-bottom: 20px;
          &:last-of-type {
            margin-bottom: 0;
          }
          .city-name {
            margin-bottom: 14px;
          }
          .school-wrap {
            display: flex;
            flex-wrap: wrap;
            .school-name {
              width: 50%;
              line-height: normal;
              display: flex;
              cursor: pointer;
              margin-bottom: 12px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              padding-right: 10px;
              box-sizing: border-box;
              .district {
                color: #999;
                margin-right: 5px;
              }
              &:hover {
                color: $primary-color;
                .district {
                  color: $primary-color;
                }
              }
            }
          }
        }
      }
    }
  }
}
.headerDefault {
  .header-title {
    color: rgba(255, 255, 255, 0.8) !important;
  }
  .icon-title {
    color: rgba(255, 255, 255, 0.8) !important;
  }
}
</style>
